module.exports = __webpack_public_path__ + "static/media/IsProgrami.5a7bd213.png";